"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPlasticsFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class SmartPlasticsFormValidator {
    static distanceSwitchCabinet(options) {
        return SmartPlasticsFormValidator.getDefaultLengthValidator(options);
    }
    static getDefaultLengthValidator(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit: echain_shared_quantities_1.LengthUnits.m,
            imperialValidator,
            imperialUnit: echain_shared_quantities_1.LengthUnits.ft,
        });
    }
    static iSenseAcceleration(options) {
        return SmartPlasticsFormValidator.getDefaultAccelerationValidator(options);
    }
    static getDefaultAccelerationValidator(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit: echain_shared_quantities_1.AccelerationUnits.m_s2,
            imperialValidator,
            imperialUnit: echain_shared_quantities_1.AccelerationUnits.ft_s2,
        });
    }
    static iSenseVelocity(options) {
        return SmartPlasticsFormValidator.getDefaultVelocityValidator(options);
    }
    static getDefaultVelocityValidator(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit: echain_shared_quantities_1.VelocityUnits.m_s,
            imperialValidator,
            imperialUnit: echain_shared_quantities_1.VelocityUnits.ft_s,
        });
    }
    static iSenseFillWeight(options) {
        return SmartPlasticsFormValidator.getDefaultWeightValidator(options);
    }
    static getDefaultWeightValidator(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0.1,
        });
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit: echain_shared_quantities_1.WeightPerLengthUnits.kg_m,
            imperialValidator,
            imperialUnit: echain_shared_quantities_1.WeightPerLengthUnits.lbs_ft,
        });
    }
    static lengthSMSSensorCable(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 1,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            thresholdMin: 1,
            thresholdMax: 10,
        });
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            thresholdMin: 3.28,
            thresholdMax: 32.8,
        });
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityRangeValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit: echain_shared_quantities_1.LengthUnits.m,
            imperialValidator,
            imperialUnit: echain_shared_quantities_1.LengthUnits.ft,
        });
    }
}
exports.SmartPlasticsFormValidator = SmartPlasticsFormValidator;
//# sourceMappingURL=SmartPlasticsFormValidator.js.map